import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { InputBase as InputBaseMemoized } from '../InputBase/InputBase.js';

/** Input allows users to enter a shorter form of text into a UI. They typically appear in forms and dialogs. */
var Input = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(InputBaseMemoized, _extends({}, props, {
    ref: ref
  }));
});
var InputMemoized = /*#__PURE__*/React.memo(Input);
InputMemoized.displayName = 'Input';

export { InputMemoized as Input };
//# sourceMappingURL=Input.js.map
